import { toGenericPriceKey } from '../assets'
import { TokenList } from '../types'
import { FlashLiquiditiesOnChain } from './types'

/**
 * Add prices to get dollar flash liquidties
 * Ideal for de-based flash loans
 */
export function attachPricesToFlashLiquidity(
  chainId: string,
  liq: FlashLiquiditiesOnChain,
  prices: { [k: string]: number },
  list: TokenList = {},
) {
  let liqCopy = { ...liq }

  Object.entries(liq).forEach(([asset, entry]) => {
    const priceKey =
      list[asset]?.assetGroup ?? toGenericPriceKey(asset, chainId)
    const price = prices[priceKey] ?? 0
    liqCopy[asset] = entry.map((e) => ({
      ...e,
      // absent when the token amount itself is unknown — never 0, which reads
      // as "no liquidity" rather than "not priced"
      availableUSD: e.available === undefined ? undefined : e.available * price,
    }))
  })

  return liqCopy
}
